import colors from './colors';
import borders from './borders';
import sizing from './sizing';
const typographyBase = {
    fontSize: '1.6rem',
    fontFamily: 'Gilroy, Monserrat, "Open Sans", Arial, Helvetica, sans-serif',
    fontWeight: 400,
    lineHeight: '2.4rem',
    margin: '0',
    letterSpacing: 'normal',
    color: colors.neutrals.textAlpha,
    textAlign: 'start'
};
const headingBase = {
    ...typographyBase,
    fontWeight: 700,
    color: colors.neutrals.textAlpha
};
const linkBase = {
    ...typographyBase,
    ...borders.bottom,
    ...borders.variant.primary,
    fontWeight: 600,
    textDecoration: 'none'
};
const tabBase = {
    ...linkBase,
    lineHeight: sizing.lineHeights.x3,
    padding: `${sizing.component.padding.small} 0`,
    borderColor: colors.neutrals.transparent,
    display: 'inline-flex'
};
const typography = {
    centered: { textAlign: 'center' },
    inverted: { color: colors.neutrals.background },
    bold: { color: colors.brand.primary.alpha },
    strong: { fontWeight: 700 },
    defaultMarginBottom: {
        marginBottom: '2.4rem'
    },
    heading: {
        h1: {
            ...headingBase,
            fontSize: '8.4rem',
            lineHeight: '9.6rem',
            letterSpacing: '-0.15rem'
        },
        h2: {
            ...headingBase,
            fontSize: '6rem',
            lineHeight: '7.2rem',
            letterSpacing: '-0.1'
        },
        h3: {
            ...headingBase,
            fontSize: '4.4rem',
            lineHeight: '4.8rem',
            letterSpacing: '-0.05rem'
        },
        h4: {
            ...headingBase,
            fontSize: '3.6rem',
            lineHeight: '4.8rem',
            letterSpacing: '-0.025rem'
        },
        h5: {
            ...headingBase,
            fontSize: '3.2rem',
            lineHeight: '4.8rem',
            letterSpacing: '-0.02rem'
        },
        h6: {
            ...headingBase,
            fontSize: '1.8rem',
            lineHeight: '2.4rem'
        }
    },
    paragraph: {
        small: {
            ...typographyBase,
            fontSize: '1.4rem',
            lineHeight: '2.4rem'
        },
        regular: typographyBase,
        large: {
            ...typographyBase,
            fontSize: '1.8rem',
            lineHeight: '2.4rem'
        }
    },
    eyebrow: {
        ...typographyBase,
        padding: 0,
        lineHeight: '2.4rem',
        fontSize: '1.2rem',
        fontWeight: 600,
        letterSpacing: '0.1rem',
        textTransform: 'uppercase',
        display: 'block'
    },
    link: {
        small: { ...linkBase, fontSize: '1.4rem' },
        regular: linkBase,
        large: {
            ...linkBase,
            fontSize: '1.8rem'
        }
    },
    tab: {
        base: tabBase,
        active: {
            ...tabBase,
            borderColor: colors.brand.primary.alpha
        },
        hovered: {
            ...tabBase,
            borderColor: colors.brand.primary.alpha,
            color: colors.brand.primary.alpha
        }
    }
};
export default typography;
//# sourceMappingURL=typography.js.map